//@ts-nocheck
import moment from 'moment';
import { IService, IVisitResponse } from '../types';
import { IEventsPerDay } from '../../pages/AdminPanel/Visits/VisitsCalendar/visitsCalendar.interface';

export const getBookedVisitTime = (
  visits: IVisitResponse[] | IEventsPerDay[] | undefined,
  service: IService
): Date[] => {
  const blockedTimeSlots = new Set<string>();

  const visitCountMap: { [key: string]: { count: number; serviceId: string } } =
    {};

  (visits || []).forEach((visit) => {
    const timeKey = moment(visit.startTime).toISOString();
    if (visitCountMap[timeKey]) {
      visitCountMap[timeKey].count += 1;
    } else {
      visitCountMap[timeKey] = {
        count: 1,
        serviceId: visit.serviceId,
      };
    }
  });

  (visits || []).forEach((visit) => {
    const startTime = moment(visit.startTime);
    const timeKey = startTime.toISOString();
    const visitCount = visitCountMap[timeKey];

    const shouldBlockDuration =
      visitCount.count >= service.numberOfVisitsAtTime ||
      visitCount.serviceId !== service._id;

    if (shouldBlockDuration) {
      let endTime: moment.Moment;
      if (visit.endTime) {
        endTime = moment(visit.endTime);
      } else {
        const serviceDuration =
          service.duration || (service.isRelatedToExercise ? 60 : 15);
        endTime = startTime.clone().add(serviceDuration, 'minutes');
      }

      let currentSlot = startTime.clone();
      while (currentSlot.isBefore(endTime)) {
        blockedTimeSlots.add(currentSlot.toISOString());
        currentSlot.add(15, 'minutes');
      }
    }
  });

  return Array.from(blockedTimeSlots).map((timeString) => new Date(timeString));
};

export const getAllBookedTime = (
  visitMap: any,
  timeInterval: number | undefined
): Date[] => {
  if (!visitMap) {
    return [];
  }

  const timeCount = new Map<string, number>();
  Object.values(visitMap).forEach(({ bookedVisitTime }, _, arr) => {
    bookedVisitTime.forEach((time) => {
      const timeString = time.toISOString();
      timeCount.set(timeString, (timeCount.get(timeString) || 0) + 1);
    });
  });

  const totalWorkers = Object.keys(visitMap).length;

  return Array.from(timeCount).reduce((acc, [timeString, count]) => {
    if (count === totalWorkers || count > 1) {
      acc.push(moment(timeString).toDate());
    } else if (count === 1) {
      const timeObj = moment(timeString).toDate();
      const workerIsAlone = Object.entries(visitMap).some(
        ([workerId, { worker, bookedVisitTime }]) => {
          const workerBookedTimes = bookedVisitTime.map((t) => t.toISOString());
          if (workerBookedTimes.includes(timeString)) {
            const otherWorkers = Object.entries(visitMap).filter(
              ([id]) => id !== workerId
            );
            return otherWorkers.every(([, { worker: otherWorker }]) => {
              const otherStart = new Date(otherWorker.startedAt);
              const otherEnd = new Date(otherWorker.finishedAt);
              return timeObj < otherStart || timeObj >= otherEnd;
            });
          }
          return false;
        }
      );

      if (workerIsAlone) {
        acc.push(timeObj);
      }
    }
    return acc;
  }, []);
};
